'use strict';
(function () {
  angular.module('pentaApp').factory('videocall.resource', service);

  service.$inject = ['resourceHelper.factory'];
  function service(resourceHelper) {
    var url = '/progressiveApp/api/videocall'
    return resourceHelper.defaultResource(url, null, { model: 'videocall' });
  }
})();
